// Code generated - EDITING IS FUTILE. DO NOT EDIT.
//
// Generated by:
//     public/app/plugins/gen.go
// Using jennies:
//     TSTypesJenny
//     PluginTsTypesJenny
//
// Run 'make gen-cue' from repository root to regenerate.

// Generated from public/app/plugins/panel/gauge/panelcfg.cue file.

import * as common from '@grafana/schema';

export const pluginVersion = "12.4.11";

export interface GaugePanelEffects {
  barGlow?: boolean;
  centerGlow?: boolean;
  gradient?: boolean;
}

export const defaultGaugePanelEffects: Partial<GaugePanelEffects> = {
  barGlow: false,
  centerGlow: false,
  gradient: true,
};

export interface Options extends common.SingleStatBaseOptions {
  barShape: ('flat' | 'rounded');
  barWidthFactor: number;
  effects: GaugePanelEffects;
  endpointMarker?: ('point' | 'glow' | 'none');
  minVizHeight: number;
  minVizWidth: number;
  neutral?: number;
  segmentCount: number;
  segmentSpacing: number;
  shape: ('circle' | 'gauge');
  showThresholdLabels: boolean;
  showThresholdMarkers: boolean;
  sizing: common.BarGaugeSizing;
  sparkline?: boolean;
  textMode?: ('auto' | 'value_and_name' | 'value' | 'name' | 'none');
}

export const defaultOptions: Partial<Options> = {
  barShape: 'flat',
  barWidthFactor: 0.5,
  effects: {},
  endpointMarker: 'point',
  minVizHeight: 75,
  minVizWidth: 75,
  segmentCount: 1,
  segmentSpacing: 0.3,
  shape: 'gauge',
  showThresholdLabels: false,
  showThresholdMarkers: true,
  sizing: common.BarGaugeSizing.Auto,
  sparkline: true,
  textMode: 'auto',
};
